import type { ReactNode } from 'react';
import type { MugshotConfig } from '@/shared/lib/mugshot';

export type SuspectSlot = {
  /** Stable react key. */
  id: string;
  name: string;
  mugshot: MugshotConfig;
  /** "host" badge in the top-right corner. */
  isHost?: boolean;
  /** "you" badge + self-glow outline. */
  isSelf?: boolean;
  /** When set, the polaroid is interactive — clicking opens MugshotEditor. */
  onMugshotChange?: (next: MugshotConfig) => void;
  /** When set, MugshotEditor renders the rename field. */
  onNameChange?: (next: string) => void;
  /** When set, the × corner button shows. */
  onRemove?: () => void;
};

export type SuspectBoardTrailing =
  | { kind: 'recruit'; onRecruit: () => void; label: string }
  | { kind: 'wanted' }
  | { kind: 'none' };

export type SuspectBoardProps = {
  slots: readonly SuspectSlot[];
  /** Hard cap surfaced in the count chip. */
  maxSlots: number;
  /** Handwritten roster header — e.g. "Suspects" / "Briefing room". */
  header: string;
  /** Trailing tile after the slots: recruit button, wanted placeholder, or nothing. */
  trailing?: SuspectBoardTrailing;
  /** Optional content above the header (e.g. eyebrow chip, sealed note). */
  topSlot?: ReactNode;
  /** Forwarded to MugshotEditor for online analytics scoping. */
  analyticsMode?: 'standalone' | 'online';
  analyticsRoomId?: string | null;
};

export const gridColsFor = (count: number): number => {
  if (count <= 1) return 1;
  if (count <= 4) return 2;
  if (count <= 9) return 3;
  return 4;
};
